// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3R2vO","clinicsSelect":"styles_clinicsSelect__3jGVC"};